import { render, staticRenderFns } from "./MailingGuideCheck.vue?vue&type=template&id=0a9d5668&"
import script from "./MailingGuideCheck.vue?vue&type=script&lang=js&"
export * from "./MailingGuideCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports